"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _SortIcon = _interopRequireDefault(require("./SortIcon"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var HeaderCellDiv = _styledComponents["default"].div.attrs(function () {
  return {
    className: "d-flex align-items-end bcr-table-header-cell"
  };
}).withConfig({
  displayName: "HeaderCell__HeaderCellDiv",
  componentId: "ls9m5o-0"
})(["&&&{height:", "px;min-width:", "px;font-weight:700;font-size:0.875rem;color:", ";", ";", "}"], function (props) {
  return props.elemHeight;
}, function (props) {
  return props.elemWidth;
}, function (props) {
  return props.theme["mlb-blue"];
}, function (props) {
  return props.backgroundColor ? "background: ".concat(props.backgroundColor) : "";
}, function (props) {
  return props.sortable && "cursor: pointer;";
});

var HeaderText = _styledComponents["default"].div.withConfig({
  displayName: "HeaderCell__HeaderText",
  componentId: "ls9m5o-1"
})(["width:100%;"]);

var HeaderCell = function HeaderCell(_ref) {
  var width = _ref.width,
      headerHeight = _ref.headerHeight,
      columnId = _ref.columnId,
      sortable = _ref.sortable,
      onClick = _ref.onClick,
      backgroundColor = _ref.backgroundColor,
      sortDirection = _ref.sortDirection,
      sorted = _ref.sorted,
      cellClass = _ref.cellClass,
      name = _ref.name;
  return _react["default"].createElement(HeaderCellDiv, {
    elemWidth: width,
    elemHeight: headerHeight,
    key: columnId,
    id: columnId,
    sortable: sortable,
    onClick: onClick,
    backgroundColor: backgroundColor
  }, _react["default"].createElement(HeaderText, {
    className: cellClass
  }, name, sorted && _react["default"].createElement(_SortIcon["default"], {
    direction: sortDirection
  })));
};

HeaderCell.propTypes = {
  name: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node, _propTypes["default"].element]).isRequired,
  width: _propTypes["default"].number,
  headerHeight: _propTypes["default"].number,
  columnId: _propTypes["default"].string,
  sortable: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  backgroundColor: _propTypes["default"].string,
  sortDirection: _propTypes["default"].string,
  sorted: _propTypes["default"].bool,
  cellClass: _propTypes["default"].string
};
HeaderCell.defaultProps = {
  width: 50,
  headerHeight: 35,
  columnId: "",
  sortable: false,
  onClick: function onClick() {},
  backgroundColor: "",
  sortDirection: null,
  sorted: false,
  cellClass: ""
};
var _default = HeaderCell;
exports["default"] = _default;